import { Progress as BaseProgress } from "@base-ui/react/progress";
import clsx from "clsx";
import type { ReactNode } from "react";
import styles from "./Progress.module.css";

export interface ProgressProps {
  label: ReactNode;
  hideLabel?: boolean;
  /** Completed amount; null while the total is unknown (indeterminate). */
  value: number | null;
  max?: number;
  /** What is shown and announced: "12 of 85 suppliers". Defaults to a percentage. */
  valueText?: string;
  className?: string;
}

/** Progress of a task (Base UI Progress): imports, syncs and other jobs. */
export function Progress({ label, hideLabel, value, max = 100, valueText, className }: ProgressProps) {
  return (
    <BaseProgress.Root
      value={value}
      max={max}
      getAriaValueText={valueText ? () => valueText : undefined}
      className={clsx(styles.progress, className)}
    >
      <div className={styles.header}>
        <BaseProgress.Label className={hideLabel ? styles.hiddenLabel : styles.label}>{label}</BaseProgress.Label>
        {valueText ? (
          <span className={styles.value}>{valueText}</span>
        ) : (
          <BaseProgress.Value className={styles.value} />
        )}
      </div>
      <BaseProgress.Track className={styles.track}>
        <BaseProgress.Indicator className={styles.indicator} />
      </BaseProgress.Track>
    </BaseProgress.Root>
  );
}
